
import { Action } from 'redux';
import { CheckoutActionTypes } from '../checkout.types';
import { ACTION_CREATOR_NAME } from 'helpers';

export interface ClearEmailAction extends Action<CheckoutActionTypes.CLEAR_EMAIL> {
}

export const clearEmail: () => ClearEmailAction = () => ({
    type: CheckoutActionTypes.CLEAR_EMAIL
});
clearEmail[ACTION_CREATOR_NAME] = 'clearEmail';

export type ClearEmailFunc = (...args: Parameters<typeof clearEmail>) => void;